// import React, { useState } from 'react';
// import { Typography, Grid, Button, Snackbar } from "@mui/material";
// import { post, put } from '../../../utils/api';
// import { startCase } from 'lodash';
// import { Height } from '@mui/icons-material';

// interface AppTokensProps {
//     module: string;
//     primary_key: string;
//     primary_key_value:any;
// }

// interface FormData {
//     token?: string;
//     // Add other properties if needed
// }

// const AppTokens: React.FC<AppTokensProps> = (props:any) => {
//     console.log("propsfff", props)
//     const [formData, setFormData] = useState<FormData>({});
//     const [clientId, setClientId] = useState<any>(props.primary_key_value);
//     const [token, setToken] = useState<string>("");
//     const [snackbarOpen, setSnackbarOpen] = useState<boolean>(false);
//     const [snackbarMessage, setSnackbarMessage] = useState<string>("");

//     const generateToken = async () => {
//         try {
//             const response: any = await post(`${props.module}/${props.primary_key_value}`, {});
//             console.log("Response token", response);
//             setToken(response.accessToken);
//             setClientId(response.clientId); // Assuming clientId is returned with the token

//             // Update the formData with the new token
//             const updatedFormData = { ...formData, token: response.accessToken };
//             setFormData(updatedFormData);
//             await updateFormData(updatedFormData);
//             setSnackbarMessage("Token generated successfully!");
//         } catch (error) {
//             console.error("Error fetching data: ", error);
//             setSnackbarMessage("Failed to generate token.");
//         } finally {
//             setSnackbarOpen(true);
//         }
//     };

//     const updateFormData = async (updatedData: FormData) => {
//         try {
//             await put(`${props.module}/${props.primary_key}`, updatedData);
//         } catch (error) {
//             console.error("Failed to update data:", error);
//         }
//     };

//     const handleSnackbarClose = () => {
//         setSnackbarOpen(false);
//     };

//     return (
//         <div className="content">
//             <h2>App Tokens</h2>
//             <Grid container spacing={3} sx={{ marginBottom: 4, marginTop: 2 }}>
//                 <Grid item xs={12} md={3}>
//                     <Typography variant="subtitle2" sx={{ fontWeight: 500,marginBottom: 2, fontSize: "13px", color: "#555" }}>
//                         {startCase("Client id".replaceAll("_", " "))}
//                     </Typography>
//                     <Typography variant="subtitle2" sx={{ fontWeight: 500, marginTop: 2, fontSize: "13px", color: "#555" }}>
//                         {startCase("token".replaceAll("_", " "))}
//                     </Typography>
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                     <Typography variant="body1" sx={textStyle}>
//                         {clientId}
//                     </Typography>
//                     <Typography variant="body1" sx={textStyle}>
//                         {token}
//                     </Typography>
//                 </Grid>
//             </Grid>
//             <Grid container spacing={3} >
//                 <Grid item xs={12} md={6}>
//                     <Button
//                         variant="outlined"
//                         onClick={generateToken}
//                         sx={{
//                             marginTop: 1,
//                             color: "#DB561E",
//                             borderColor: "#DB561E",
//                             "&:hover": {
//                                 color: "#FFFFFF",
//                                 backgroundColor: "#DB561E",
//                                 borderColor: "#FFFFFF",
//                             },
//                         }}
//                     >
//                         Generate Token
//                     </Button>
//                 </Grid>
//             </Grid>
//             <Snackbar
//                 open={snackbarOpen}
//                 autoHideDuration={6000}
//                 onClose={handleSnackbarClose}
//                 message={snackbarMessage}
//             />
//         </div>
//     );
// };

// const textStyle = {
//     fontSize: "12px",
//     fontWeight: 400,
//     backgroundColor: "#fff",
//     padding: "6px",
//     borderRadius: "1px",
//     marginBottom: 2,
//     border: "1px solid #e0e0e0",
//     Height:"200px",
//     maxHeight: "200px",
//     overflow: "auto",
//     whiteSpace: "pre-wrap",
//     wordBreak: "break-word",
// };

// export default AppTokens;



import React, { useEffect, useState } from 'react';
import { Typography, Grid, Button, Snackbar } from "@mui/material";
import { get, post, put } from '../../../utils/api';
import { startCase } from 'lodash';

interface AppTokensProps {
    module: string;
    primary_key: string;
    primary_key_value: any;
}

interface FormData {
    token?: string;
}

const AppTokens: React.FC<AppTokensProps> = (props) => {
    const [formData, setFormData] = useState<FormData>({});
    const [clientId, setClientId] = useState<string>(props.primary_key_value);
    const [token, setToken] = useState<string>("");
    const [snackbarOpen, setSnackbarOpen] = useState<boolean>(false);
    const [snackbarMessage, setSnackbarMessage] = useState<string>("");

    useEffect(() => {
        getData();
    }, [props.module]);

    const getData = async () => {
        let params = { [props.primary_key]: props.primary_key_value };
        try {
            const response = await get(`${props.module}/details`, params);
            if (response.data.token) {
                setToken(response.data.token);
            }
        } catch (error) {
            console.log("Error fetching data: ", error);
        }
    };

    const generateToken = async () => {
        try {
            const response: any = await post(`${props.module}/${props.primary_key_value}`, {});
            setToken(response.accessToken);
            // setClientId(response.clientId); // Assuming `clientId` is returned with the token
            // const updatedFormData = { ...formData, token: response.accessToken };
            const updatedFormData = { token: response.accessToken };

            setFormData(updatedFormData);
            await updateFormData(updatedFormData);
            setSnackbarMessage("Token generated successfully!");
        } catch (error) {
            console.error("Error fetching data: ", error);
            setSnackbarMessage("Failed to generate token.");
        } finally {
            setSnackbarOpen(true);
        }
    };

    const updateFormData = async (updatedData: FormData) => {
        try {
            await put(`${props.module}/${props.primary_key_value}`, updatedData);
        } catch (error) {
            console.error("Failed to update data:", error);
        }
    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };

    return (
        <div className="content">
            <Typography variant="h5" sx={{ marginBottom: 2 }}>App Tokens</Typography>
            <Grid container spacing={3} sx={{ marginBottom: 4, marginTop: 2 }}>
                <Grid item xs={12} md={3}>
                    <Typography variant="subtitle2" sx={labelStyle}>
                        {startCase(props.primary_key.replaceAll("_", " "))}
                    </Typography>
                    <Typography variant="subtitle2" sx={labelStyle}>
                        {startCase("token".replaceAll("_", " "))}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Typography variant="body1" sx={textStyle}>{clientId}</Typography>
                    <Typography variant="body1" sx={textStyle}>{token}</Typography>
                </Grid>
            </Grid>
           
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <Button
                                variant="outlined"
                                onClick={generateToken}
                                sx={buttonStyle}
                            >
                                  {token ? "Generate New Token" : "Generate Token"}

                            </Button>
                        </Grid>
                    </Grid>
                
        
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={handleSnackbarClose}
                message={snackbarMessage}
            />
        </div>
    );
};

const labelStyle = {
    fontWeight: 500,
    marginBottom: 2,
    fontSize: "13px",
    color: "#555",
};

const textStyle = {
    fontSize: "13px",
    fontWeight: 400,
    backgroundColor: "#fff",
    padding: "6px",
    borderRadius: "4px",
    marginBottom: 2,
    border: "1px solid #e0e0e0",
    maxHeight: "200px",
    overflow: "auto",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
};

const buttonStyle = {
    marginTop: 1,
    color: "#DB561E",
    borderColor: "#DB561E",
    "&:hover": {
        color: "#FFFFFF",
        backgroundColor: "#DB561E",
        borderColor: "#FFFFFF",
    },
};

export default AppTokens;
